import { Pipe, PipeTransform } from '@angular/core';
import { CheckDetailsByMeterData } from 'oneok/customer-portal/LEGACY_MODELS/check-detail/CDDetail';

@Pipe({
  name: 'sortFilter'
})
export class SortFilter implements PipeTransform {
  transform(details: CheckDetailsByMeterData[], sortOption: string): CheckDetailsByMeterData[] | null {
    let transformed: CheckDetailsByMeterData[] | null = null;
    if (!details) {
      return transformed;
    }
    if (sortOption === 'name_asc') {
      transformed = details.sort((a, b) => a.METERNAME.localeCompare(b.METERNAME));
    } else if (sortOption === 'name_dsc') {
      transformed = details.sort((a, b) => b.METERNAME.localeCompare(a.METERNAME));
    } else if (sortOption === 'num_asc') {
      transformed = details.sort((a, b) => a.METERNUMBER.localeCompare(b.METERNUMBER));
    } else {
      transformed = details.sort((a, b) => b.METERNUMBER.localeCompare(a.METERNUMBER));
    }
    return transformed;
  }
}
